//Have to have the following logic within utils package to avoid circular dependency
let deferMetrics = {};
const UNKNOWN_COMPONENT_NAME = 'UNKNOWN';

export function clearDeferMetrics() {
	deferMetrics = {};
}

export function logDuration(metrics, duration = 0, incomingComponentName) {
	const componentName = incomingComponentName ? incomingComponentName : UNKNOWN_COMPONENT_NAME;
	if (!metrics[componentName]) metrics[componentName] = [];

	metrics[componentName].push(duration);
}

export function getDeferMetrics() {
	return deferMetrics;
}

export function logDeferTiming(duration) {
	logDuration(deferMetrics, duration);
}
